import { useEffect, useState } from "react";
import BackLink from "../components/backLink/BackLink";
import CaseArrows from "../components/caseArrows/CaseArrows";
import CaseDisplay from "../components/casesDisplay/CaseDisplay";
import Logo from "../components/logo/Logo";
import Motion from "../components/motion";
import PostBox from "../components/postBox/PostBox";
import { useCases } from "../providers/Cases";

const CasesPage = () => {
  const { casesLoad } = useCases();
  const [load, setLoad] = useState(false);
  const [reLoad, setReload] = useState(true);

  setTimeout(() => {
    setLoad(true);
  }, 1000);

  const handleResize = () => {
    setReload(false);
    setTimeout(() => setReload(true), 1000);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Logo />
      {casesLoad ? (
        <></>
      ) : (
        <>
          <Motion>
            <CaseDisplay />
            {load && reLoad && <CaseArrows />}
          </Motion>
        </>
      )}
      <PostBox />
      <BackLink />
    </>
  );
};

export default CasesPage;
